import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import BgImg from "../../images/services-usa/web-app-dev/why_choose.webp";

function Whychoosewebapp() {
  return (
    <section
      className="why_choose_webapp p-100 text_white"
      style={{
        backgroundImage: `url(${BgImg})`,
        backgroundRepeat: "no-repeat",
      }}
    >
      <Container>
        <Row>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
            <h2>
              Why Choose TekRevol as Your{" "}
              <span>Web App Development Company?</span>
            </h2>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
            <p>
              TekRevol stands out as an ideal web application development
              company with significant technical and business expertise.
              Businesses looking for a partner with a proven ability to deliver
              market-leading web solutions and an unwavering client focus should
              consider partnering with us.
            </p>
          </Col>
        </Row>
        <Row className="mt-3 mt-md-4">
          <Col xs={12} md={12} lg={12} xl={12} xxl={12}>
            <div className="why-choose-web-main">
              <div className="why-choose-item">
                <div className="why-choose-box">
                  <div className="num">01</div>
                  <div className="why-choose-content">
                    <h5>Expertise & Experience</h5>
                    <p>
                      Our developers are adept at programming flexible and
                      potent web applications with the most suitable frameworks.
                    </p>
                  </div>
                </div>
              </div>
              <div className="why-choose-item">
                <div className="why-choose-box">
                  <div className="num">02</div>
                  <div className="why-choose-content">
                    <h5>Transparent Communication</h5>
                    <p>
                      We emphasize communication transparency and integrate the
                      use of models that will enable you to track the progress
                      made in software development.
                    </p>
                  </div>
                </div>
              </div>
              <div className="why-choose-item">
                <div className="why-choose-box">
                  <div className="num">03</div>
                  <div className="why-choose-content">
                    <h5>Scalability by Design</h5>
                    <p>
                      We focus on web apps that can be scaled with your business
                      needs through the use of technology such as cloud and
                      scalability.
                    </p>
                  </div>
                </div>
              </div>
              <div className="why-choose-item">
                <div className="why-choose-box">
                  <div className="num">04</div>
                  <div className="why-choose-content">
                    <h5>Technical Excellence</h5>
                    <p>
                      Our team works with the latest web technology and trending
                      technologies are implemented in your application.
                    </p>
                  </div>
                </div>
              </div>
              <div className="why-choose-item">
                <div className="why-choose-box">
                  <div className="num">05</div>
                  <div className="why-choose-content">
                    <h5>Cost-Effective Solutions</h5>
                    <p>
                      We build clean, robust, professional web applications that
                      will drive substantial ROI in your business.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Whychoosewebapp;
